export const getStripeFee = ({ total, stripePercentageFee, stripeFixedFee }) =>
  +(+stripeFixedFee + (+total * +stripePercentageFee) / 100).toFixed(2);
